export enum EnumTipoBoleto {
    ARRECADACAO = 'ARRECADACAO',
    SIMPLES = 'SIMPLES',
    boleto = 'boleto',
    conta_consumo = 'conta_consumo'
}



// WEBPACK FOOTER //
// ./src/app/resources/enum/enumTipoBoleto.ts